import { render } from "./AdminSidebar.vue?vue&type=template&id=693d5c66&scoped=true&ts=true"
import script from "./AdminSidebar.vue?vue&type=script&lang=ts"
export * from "./AdminSidebar.vue?vue&type=script&lang=ts"

import "./AdminSidebar.vue?vue&type=style&index=0&id=693d5c66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693d5c66"]])

export default __exports__